import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import styles from '../Europass.module.scss'
import { Layout } from 'components'

import userInfo from 'utils/userInfo'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  setEuropass,
  setPersonalInfo,
  setUser_change,
} from 'store/slices/PersonalCard'
import { getPersonalEmployee } from 'service/PersonalCardService'
import ProfilePage from 'pages/ProfilePage/ProfilePage'

const EuropassKy = () => {
  const { t } = useTranslation('common')

  const user = userInfo()
  const [render, setRender] = useState(false)

  const info = useSelector((state) => state.personalcard.personal_info)
  const navigate = useNavigate()
  let data
  const dispatch = useDispatch()
  const [email, setEmail] = useState(false)
  const [phone, setPhone] = useState(false)
  const [citizen, setCitizen] = useState(false)
  const [address, setAddress] = useState(false)
  const [birth_date, setBirth_date] = useState(false)
  const [education, setEducation] = useState(false)
  const [diplomatic, setDiplomatic] = useState(false)
  const [military, setMilitary] = useState(false)
  const [activity, setActivity] = useState(false)
  const [trainQualif, setTrainQualif] = useState(false)
  const [profession, setProfession] = useState(false)

  const getDataStart = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ky')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getDataStart()

    setRender(false)
  }, [render])

  const getData = async () => {
    try {
      const check = { ...info }
      const change_user = { ...user }
      if (phone) {
        change_user.numberPhone = null
      }
      if (email) {
        change_user.email = null
      }

      if (citizen) {
        change_user.education = null
      }
      if (address) {
        info.birth_place.street = null
      }
      if (birth_date) {
        change_user.dataOfBirth = null
      }
      if (education) {
        check.education = null
      }
      if (diplomatic) {
        check.ranks = null
      }
      if (military) {
        check.military_registration = null
      }
      if (activity) {
        check.awards = null
      }
      if (trainQualif) {
        check.trainings = null
      }
      if (profession) {
        check.surname = null
      }
      dispatch(
        setEuropass({
          Europass: check,
        }),
      )
      dispatch(
        setUser_change({
          user_change: change_user,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [
    email,
    phone,
    citizen,
    address,
    birth_date,
    education,
    diplomatic,
    military,
    activity,
    trainQualif,
    profession,
  ])

  return (
    <Layout>
      <div className={styles.personal_wrapper}>
        <div className={styles.header}>
          <h3 className={styles.Personal_Card}>{t('auto.europassky_europassky.k1')}</h3>
          <div className={styles.header_body}>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              <button
                className={styles.btn1}
                onClick={() => navigate('/europass')}
                style={{}}
              >
                Русский{' '}
              </button>
              <button
                className={styles.btn1}
                onClick={() => navigate('/europassen')}
              >
                English
              </button>
              <button className={styles.btn1}>{t('lang.ky')}</button>
            </div>
          </div>
        </div>
        <button
          style={{ width: '150px', marginBottom: '30px' }}
          onClick={() => navigate('/personalcard')}
          className={styles.btn1}
        >
          Артка
        </button>

        <div className={styles.body}>
          <h3>{t('auto.europassky_europassky.k2')} </h3>

          <div className={styles.list}>
            <h3>{t('auto.europassky_europassky.k3')}</h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setEmail(e.target.checked)}
                checked={email}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('auto.europassky_europassky.k4')}</h4>
                <p>{user.email}</p>
              </div>

              <div className={styles.item}>
                <input
                  onChange={(e) => setPhone(e.target.checked)}
                  checked={phone}
                  type="checkbox"
                  className={styles.radio}
                />
                <div>
                  <h4>{t('auto.europassky_europassky.k5')}</h4>
                  <p>{user.numberPhone}</p>
                </div>

                <div className={styles.item}>
                  <input type="checkbox" className={styles.radio} />
                  <div>
                    <h4>{t('auto.europassky_europassky.k6')}</h4>
                    <p>{info?.citizenship}</p>
                  </div>
                </div>
                
                <div className={styles.item}>
                  <input
                    onChange={(e) => setBirth_date(e.target.checked)}
                    checked={birth_date}
                    type="checkbox"
                    className={styles.radio}
                  />
                  <div>
                    <h4>{t('auto.europassky_europassky.k7')}</h4>
                    <p>{user.dataOfBirth}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.list}>
            <h3>{t('auto.europassky_europassky.k8')}</h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setEducation(e.target.checked)}
                checked={education}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('archive.filter_university')}</h4>
                <p>{info.education?.institution}</p>
              </div>

              <div className={styles.item}>
                <div>
                  <h4>{t('archive.col_faculty')}</h4>
                  <p>{info?.education?.department}</p>
                </div>
              </div>
              <div className={styles?.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k9')}</h4>
                  <p>{info?.education?.qualification}</p>
                </div>
              </div>
              <div className={styles?.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k10')}</h4>
                  <p>{info?.education?.entered}</p>
                </div>
              </div>

              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k11')}</h4>
                  <p>{info?.education?.graduated}</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.list}>
            <h3>{t('auto.europassky_europassky.k12')} </h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setDiplomatic(e.target.checked)}
                checked={diplomatic}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k13')}</h4>
                  <p>{info?.ranks[1]?.title}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k14')}</h4>
                  <p>{info?.ranks[1]?.rank}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k15')}</h4>
                  <p>{info?.ranks[1]?.assigned}.</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k16')}</h4>
                  <a>{info?.ranks[1]?.certification}</a>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.list}>
            <h3>{t('auto.europassky_europassky.k17')} </h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setMilitary(e.target.checked)}
                checked={military}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('auto.europassky_europassky.k18')}</h4>
                {info?.military_registration?.is_fit ? (
                  <p>{t('auto.europassky_europassky.k19')}</p>
                ) : (
                  <p>{t('auto.europassky_europassky.k20')}</p>
                )}
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k21')}</h4>
                  <p>{info?.military_registration?.draft_board}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k22')}</h4>
                  <p>{info?.military_registration?.composition}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.vus')}</h4>
                  <p>{info?.military_registration?.rank}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k23')}</h4>
                  <p>{info?.military_registration?.specialty}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k24')}</h4>
                  <p>{info?.military_registration?.troop_kind}</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.list}>
            <h3>{t('auto.europassky_europassky.k25')}</h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setActivity(e.target.checked)}
                checked={activity}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('auto.europassky_europassky.k9')}</h4>
                <p>{info?.employment?.professional_experience}</p>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k26')}</h4>
                  <p>{info?.employment?.total_experience}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k27')}</h4>
                  <p>{info?.employment?.public_service_experience}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('auto.europassky_europassky.k28')}</h4>
                  <p>{info?.employment?.private_service_experience}</p>
                </div>
              </div>
            </div>
          </div>

          {info?.employment?.experiences.length === 0 ? null : (
            <div className={styles.list}>
              <h3>
                {t('auto.europassky_europassky.k29')}
              </h3>
              <div className={styles.item}>
                <input
                  onChange={(e) => setProfession(e.target.checked)}
                  checked={profession}
                  type="checkbox"
                  className={styles.radio}
                />
                <div>
                  <h4>{t('auto.europassky_europassky.k30')}</h4>
                  <p>{info?.employment?.experiences[0].position}</p>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('auto.europassky_europassky.k31')}</h4>
                    <p>{info?.employment?.experiences[0].organization}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('auto.europassky_europassky.k32')}</h4>
                    <p>{info?.employment?.experiences[0].organization}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('auto.europassky_europassky.k33')}</h4>
                    <p>{info?.employment?.experiences[0].started}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('auto.europassky_europassky.k34')}</h4>
                    <p>{info?.employment?.experiences[0].ended}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <button
            className={styles.btn1}
            onClick={() => navigate('/finaleuropassky')}
          >
            Европас формасы бекитүү
          </button>
        </div>
      </div>
    </Layout>
  )
}

export default EuropassKy
